import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import cronJobsService from '../services/cronJobsService';
import { queryKeys } from './queryKeys';

const cronJobsDefaults = {
  staleTime: 0,
  gcTime: 5 * 60 * 1000,
  refetchOnMount: 'always',
};

export function useCronJobs(options = {}) {
  return useQuery({
    queryKey: queryKeys.cronJobs.all,
    queryFn: () => cronJobsService.getAllJobs(),
    ...cronJobsDefaults,
    ...options,
  });
}

export function useDeleteCronJob(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id => cronJobsService.deleteJob(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useUpdateCronJob(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => cronJobsService.updateJob(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useCreateCronJob(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => cronJobsService.createJob(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
